import {createApp} from "vue";

import {initializeApp} from "firebase/app";
import vuetify from "./plugins/vuetify";
import {createRouter, createWebHistory} from "vue-router";
import VueApexCharts from "vue3-apexcharts";
// perfectscrollbar plugins
import PerfectScrollbar from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
import App from "./App.vue";
import BaseCard from "./components/base/BaseCard.vue";
import "./plugins/script.js";
import "@/assets/styles/_main.scss";
import "@/assets/fonts/theiconof.css";
import "/src/assets/fonts/IranSans/css/fontiran.css";
// @ts-ignore
import {loadFonts} from "./plugins/webfontloader";
// @ts-ignore
import {createPinia} from 'pinia';
// @ts-ignore
import i18n from './plugins/i18n.js';
// @ts-ignore
import router from "./plugins/router.js";
import piniaPluginPersistedStates from "pinia-plugin-persistedstate";
import Vue3Toasity, {type ToastContainerOptions} from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'


const firebaseConfig = {
    apiKey: "AIzaSyC254ogc6A16RvlNjX7TBXMHz8yHDXroAQ",
    authDomain: "elevated-oven-356415.firebaseapp.com",
    projectId: "elevated-oven-356415",
    storageBucket: "elevated-oven-356415.appspot.com",
    messagingSenderId: "637915129389",
    appId: "1:637915129389:web:84d199b2e35478c8fd7aa4",
    measurementId: "G-HG6W193RTM"
};

initializeApp(firebaseConfig);
loadFonts();

const piniaApp = createPinia();
piniaApp.use(piniaPluginPersistedStates);

// @ts-ignore
const app = createApp(App);


app
    .use(piniaApp)
    .use(vuetify)
    .component("BaseCard", BaseCard)
    .use(PerfectScrollbar)
    .use(VueApexCharts)
    .use(i18n)
    .use(router)
    .use(Vue3Toasity, {
            autoClose: 6000,
            // ...
        } as ToastContainerOptions,
    ).use(Vue3PersianDatetimePicker, {
    name: 'CustomDatePicker',
    props: {
        format: 'YYYY-MM-DD',
        displayFormat: 'jYYYY-jMM-jDD',
        editable: false,
        inputClass: 'v-field v-input__control v-field__input',
        placeholder: 'لطفا یک تاریخ را انتخاب کنید',
        altFormat: 'YYYY-MM-DD HH:mm',
        color: '#00acc1',
        autoSubmit: false,
        //...
        //... And whatever you want to set as default.
        //...
    }
})
    .mount("#app");
